export const environment = {
  production: false,
  socketServerUrl: 'https://dev.gpion.io/ws',
  featureFlagX: true,
  cognitoUserPoolId: 'eu-central-1_r0wmKYPAZ',
  cognitoUserPoolClientID: '3ha6c12qnjaoial6sgr7lj13fs',
};
